import { useState } from "react";
import { Flex, Box, useColorModeValue } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  getNoiseCapture,
  getMotionCapture
} from "src/modules/activity-log/duck/selectors";
import {
  updateNoiseCapture,
  updateMotionCapture
} from "src/modules/activity-log/duck/actions";
import { updateCloudSettings } from "src/modules/auth/ajax/cloud";
import { useTranslation } from "react-i18next";
import { useApp } from "src/components/App/Context";
import NavigationBar from "src/components/NavigationBar";
import { H3, BodyText2 } from "src/atoms/typography";
import RadioItem from "./RadioItem";
import eventOptions from "./eventsOptions";

function EventSettings({ onClose, onBack }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const app = useApp();
  const storedNoiseCapture = useSelector(getNoiseCapture);
  const storedMotionCapture = useSelector(getMotionCapture);
  const [onNoise, setOnNoise] = useState(storedNoiseCapture);
  const [onMotion, setOnMotion] = useState(storedMotionCapture);

  async function handleNoiseCaptureChange(capture) {
    dispatch(updateNoiseCapture(capture));
    setOnNoise(capture);
    await updateCloudSettings({ activity_log_noise_capture: capture });
    synchronize();
  }

  async function handleMotionCaptureChange(capture) {
    dispatch(updateMotionCapture(capture));
    setOnMotion(capture);
    await updateCloudSettings({ activity_log_motion_capture: capture });
    synchronize();
  }

  function synchronize() {
    app.synchronizer.announceItemChange(
      app.synchronizer.SynchronizableItems.CLOUD_SETTINGS
    );
  }

  const borderColor = useColorModeValue("black12", "white8");
  return (
    <>
      <NavigationBar
        headingKey="events.heading"
        onClose={onClose}
        onBack={onBack}
      />
      <Box p="24px">
        <BodyText2 color="mediumEmphasis" mb="24px">
          {t("events.description")}
        </BodyText2>
        <Flex width="100%" gap="44px">
          <Box width="50%" borderRight="1px solid" borderColor={borderColor}>
            <H3 mb="2px" color="highEmphasis">
              {t("events.whenNoise")}
            </H3>
            {Object.values(eventOptions.noise).map(({ value, label }) => (
              <RadioItem
                key={value}
                label={t(label)}
                onChange={() => handleNoiseCaptureChange(value)}
                checked={value === onNoise}
              />
            ))}
          </Box>
          <Box width="50%">
            <H3 mb="2px" color="highEmphasis">
              {t("events.whenMotion")}
            </H3>
            {Object.values(eventOptions.motion).map(({ value, label }) => (
              <RadioItem
                key={value}
                label={t(label)}
                onChange={() => handleMotionCaptureChange(value)}
                checked={value === onMotion}
              />
            ))}
          </Box>
        </Flex>
      </Box>
    </>
  );
}

export default EventSettings;
